import { Box, makeStyles } from "@material-ui/core";
import { Button } from "..";

const AuthServiceUnavailablePage: React.FC = () => {
	const classes = useStyles();

	return (
		<Box>
			<Box paddingLeft={6} paddingTop={6} paddingBottom={3}>
				<LyfegenLogo />
			</Box>
			<div className={classes.container}>
				<p className={classes.text}>STATUS</p>
				<p className={classes.content}>
					The Lyfegen Platform is currently <br /> undergoing regular maintenance
				</p>
				<Box mb={3.4} className={classes.text}>
					We expect to get online soon, thank you for your patience.
				</Box>
				<a className={classes.link} href={"https://lyfegen-health-checks.azurewebsites.net/client-public"} target="_blank">
					<Button variant="contained" use="black">
						Check service availability
					</Button>
				</a>
			</div>
			<div
				style={{
					width: 384,
					height: 384,
					filter: "blur(100px)",
					backgroundColor: "#003538",
					opacity: 0.1,
					position: "absolute",
					top: 0,
					right: "30%",
				}}
			/>
			<div
				style={{
					width: 184,
					height: 184,
					filter: "blur(100px)",
					backgroundColor: "#003538",
					opacity: 0.3,
					position: "absolute",
					bottom: "10%",
					right: "10%",
				}}
			/>
		</Box>
	);
};

export default AuthServiceUnavailablePage;

const useStyles = makeStyles({
	dialog: {
		maxWidth: "468px",
		boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.08)",
		color: "#212121",
	},
	container: {
		fontFamily: "Satoshi",
		padding: "0 169px",
		"& p": {
			margin: 0,
		},
	},
	content: {
		paddingTop: "12px",
		paddingBottom: "64px",
		fontSize: "60px",
		fontWeight: 300,
		color: "#003538",
	},
	text: {
		fontSize: "16px",
		fontWeight: 300,
	},
	link: {
		textDecoration: "none",
	},
});

const LyfegenLogo = () => (
	<svg width="86" height="36" viewBox="0 0 121 26" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M60.88 12.035h59.925v13.037H70.867c-5.516 0-9.988-4.49-9.988-10.029v-3.008zM.954 0h49.938c5.516 0 9.987 4.49 9.987 10.029v2.006H.954V0z"
			fill="#212121"
		/>
	</svg>
);
